<div class="logo">
    <img src="./assets/image/ancytree.logo.png" alt="logo" class="logo-image">
</div>
<span i18n class="closebtn" (click)="clickClose()">
    <mat-icon>close</mat-icon>
</span>
<mat-selection-list [multiple]="false">
    <mat-list-option class="select-list" [selected]="homeSelect">
        <div class="select-list-item" routerLink="/dashboard/home">
            <mat-icon>home</mat-icon>
            <p i18n  class="select-list-text">Home</p>
        </div>
    </mat-list-option>
    <mat-list-option class="select-list" [selected]="startSelect">
        <div class="select-list-item" routerLink="/dashboard/selection">
            <mat-icon>gavel</mat-icon>
            <p i18n  class="select-list-text">Make my tree</p>
        </div>
    </mat-list-option>
    <mat-list-option class="select-list" [selected]="profileSelect">
        <div class="select-list-item" routerLink="/dashboard/profile">
            <mat-icon>account_box</mat-icon>
            <p i18n  class="select-list-text">Profile</p>
        </div>
    </mat-list-option>
    <mat-list-option class="select-list" [selected]="gedcomSelect">
        <div class="select-list-item" routerLink="/dashboard/gedcom">
            <mat-icon>people</mat-icon>
            <p i18n  class="select-list-text">Gedcom</p>
        </div>
    </mat-list-option>
    <mat-list-option class="select-list" [selected]="designsSelect">
        <div class="select-list-item" routerLink="/dashboard/designs">
            <mat-icon>palette</mat-icon>
            <p i18n  class="select-list-text">Designs</p>
        </div>
    </mat-list-option>
    <mat-list-option class="select-list" [selected]="ordersSelect">
        <div class="select-list-item" routerLink="/dashboard/orders">
            <mat-icon>calendar_today</mat-icon>
            <p i18n  class="select-list-text">Orders</p>
        </div>
    </mat-list-option>
    <mat-list-option class="select-list" [selected]="ordersSelect">
        <div class="select-list-item" routerLink="/dashboard/assistance-package">
            <mat-icon class="material-symbols-outlined">support_agent</mat-icon>
            <p i18n  class="select-list-text">Assistance Packages</p>
        </div>
    </mat-list-option>
    <mat-list-option class="select-list" [selected]="newsSelect">
        <div class="select-list-item" routerLink="/dashboard/news">
            <mat-icon>article</mat-icon>
            <p i18n  class="select-list-text">News</p>
        </div>
    </mat-list-option>
    <mat-list-option class="select-list">
        <div class="select-list-item">
            <mat-icon>help_outline</mat-icon>
            <a i18n href="https://ancytree.com/hjalp/" target="_blank" class="select-list-text">Help</a>
        </div>
    </mat-list-option>
</mat-selection-list>
<a i18n class="updated" *ngIf="!environment.production">Updated: {{updated}}</a>